import React from 'react';

import Header from './Header';
import Footer from './Footer';

import * as params from '../Config';

const Layout = ({children}) => {
    return <div className="App" class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
        <Header config={params.configuration} pages={params.pages}/>
        <main className="mdl-layout__content">
            {children}
        </main>
        <Footer pages={params.pages}/>
    </div>;
};

export default Layout;